import ability from '@/libs/acl/ability'

export default function permission() {
  const getPermissions = student => {
    const perm = {
      can_update: false,
      can_delete: false,
      can_add_student: false,
    }
    const researchAdvisorPermissions = student.applied_doc_permissions ? student.applied_doc_permissions : {}
    return {
      ...perm,
      ...researchAdvisorPermissions,
    }
  }
  const canUpdate = () => ability.can('update', 'ResearchAdvisor')

  const canDelete = () => false

  const canAddStudent = () => ability.can('add_student', 'ResearchAdvisor')

  const canCreate = () => ability.can('create', 'ResearchAdvisor')

  const canDeleteStudent = student => getPermissions(student).can_delete

  const canUpdateStudent = student => getPermissions(student).can_update

  return {
    canCreate,
    canUpdate,
    canDelete,
    canAddStudent,
    canDeleteStudent,
    canUpdateStudent,
  }
}
